import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import { BoxUpdateType, BoxUpdatePathType, ProductPackagingUpdateType } from '@schemas'

export const getBox = async ({ customHeaders = {} } = {}): Promise<
	ResType | undefined
> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/box',
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const addBox = async ({
	body = {} as BoxUpdateType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'post',
			uri: '/box',
			body: body,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateBox = async ({
	params = { boxId: '' } as BoxUpdatePathType,
	body = {} as BoxUpdateType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'put',
			uri: `/box/${params.boxId}`,
			body: body,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteBox = async ({
	params = { boxId: '' } as BoxUpdatePathType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'delete',
			uri: `/box/${params.boxId}`,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getProductPackaging = async ({ customHeaders = {} } = {}): Promise<
	ResType | undefined
> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/box/products',
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateProductPackaging = async ({
	body = { items: [] } as ProductPackagingUpdateType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'put',
			uri: '/box/products',
			body: body,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const boxApi = {
	getBox,
	addBox,
	updateBox,
	deleteBox,
	getProductPackaging,
	updateProductPackaging,
}

export default boxApi
